'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = pickupLocator;

var _lodash = require('lodash');

var _pickupLocations = require('../actions/pickupLocations');

var _presentation = require('../actions/presentation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = exports.noop = function noop() {};

var INITIAL_STATE = {
  initialTerm: '',
  locations: [],
  confirmed: false,
  gps: false,
  fetching: false,
  gpsAvailable: true,
  searchFunc: noop
};

function pickupLocator() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var locationsWithIds = function locationsWithIds(locations) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(locations.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
            i = _step$value[0],
            value = _step$value[1];

        value.id = i;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return locations;
  };

  var stringifyTerm = function stringifyTerm(term) {
    if (typeof term === 'string') {
      return term;
    }

    return '';
  };

  var locationsWithSelected = function locationsWithSelected(locations, id) {
    var newState = (0, _lodash.cloneDeep)(locations);
    var idMatch = function idMatch(location) {
      return location.id === id;
    };

    if (newState.some(idMatch)) {
      var target = newState.find(idMatch);
      var wasSelected = target.selected;

      newState.forEach(function (element) {
        return element.selected = false;
      });

      target.selected = !wasSelected;
    }

    return newState;
  };

  switch (action.type) {
    case 'SET_CLICK_AND_COLLECT':
      if (!action.enable) {
        return (0, _extends3.default)({}, state, {
          confirmed: false
        });
      }

      return (0, _extends3.default)({}, state);
    case _presentation.SHOW_PICKUP_LOCATOR:
      return (0, _extends3.default)({}, state, {
        initialTerm: stringifyTerm(action.term) || state.initialTerm,
        onOpen: action.searchFunc
      });
    case _pickupLocations.FETCH_PICKUP_LOCATIONS_BY_TERM:
      return (0, _extends3.default)({}, state, {
        initialTerm: stringifyTerm(action.term),
        gps: action.gps,
        fetching: true,
        onOpen: noop
      });
    case _pickupLocations.FETCH_PICKUP_LOCATIONS_BY_TERM_SUCCESS:
      return (0, _extends3.default)({}, state, {
        locations: locationsWithIds(action.result),
        fetching: false
      });
    case _pickupLocations.FETCH_PICKUP_LOCATIONS_BY_TERM_FAILURE:
      return (0, _extends3.default)({}, state, { fetching: false });
    case _pickupLocations.SELECT_PICKUP_LOCATION:
      return (0, _extends3.default)({}, state, { locations: locationsWithSelected(state.locations, action.id) });
    case _pickupLocations.CONFIRM_PICKUP_LOCATION:
      return (0, _extends3.default)({}, state, { confirmed: true });
    case _pickupLocations.GPS_UNAVAILABLE:
      return (0, _extends3.default)({}, state, { gpsAvailable: false });
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/pickupLocator.js
// module id = 2354
// module chunks = 0